import React from 'react';
import { Modal, Form, DatePicker, Select, Button } from 'antd';

const { Option } = Select;

const ExportModal = ({ visible, onCancel, onExport }) => {
  const [form] = Form.useForm();

  const handleOk = () => {
    form.validateFields().then((values) => {
      onExport(values);
    });
  };

  return (
    <Modal
      title="Export Transactions"
      visible={visible}
      onOk={handleOk}
      onCancel={onCancel}
      footer={[
        <Button key="back" onClick={onCancel}>
          Cancel
        </Button>,
        <Button key="submit" type="primary" onClick={handleOk}>
          Export
        </Button>,
      ]}
    >
      <Form form={form} layout="vertical">
        <Form.Item name="startDate" label="Start Date">
          <DatePicker showTime format="YYYY-MM-DD HH:mm:ss" style={{ width: '100%' }} />
        </Form.Item>
        <Form.Item name="endDate" label="End Date">
          <DatePicker showTime format="YYYY-MM-DD HH:mm:ss" style={{ width: '100%' }} />
        </Form.Item>
        <Form.Item name="status" label="Status">
          <Select placeholder="Select status">
            <Option value="PENDING">Pending</Option>
            <Option value="PROCESSING">Processing</Option>
            <Option value="SUCCESS">Success</Option>
            <Option value="FAILED">Failed</Option>
            <Option value="OTP_REQUIRED">OTP Required</Option>
            <Option value="CBA_PENDING">CBA Pending</Option>
            <Option value="EXPIRED">Expired</Option>
            <Option value="CANCELLED">Cancelled</Option>
          </Select>
        </Form.Item>
        <Form.Item name="type" label="Type">
          <Select placeholder="Select type">
            <Option value="LOCAL_FUNDS_TRANSFER">Local Funds Transfer</Option>
            <Option value="INTER_BANK_TRANSFER">Inter-Bank Transfer</Option>
            <Option value="NAME_ENQUIRY">Name Enquiry</Option>
            <Option value="BILLS_PAYMENT">Bills Payment</Option>
            <Option value="CREDIT">Credit</Option>
            <Option value="DEBIT">Debit</Option>
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ExportModal;
